import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=2dea84e6&scoped=true"
import script from "./Users.ts?vue&type=script&lang=ts&external"
export * from "./Users.ts?vue&type=script&lang=ts&external"
import style0 from "./Users.vue?vue&type=style&index=0&id=2dea84e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea84e6",
  null
  
)

export default component.exports